import React, { useState, useRef } from "react";
import api, { NEW_BASE_URL, studioApi } from "../api";
import { message } from "antd";

export interface IPdfs {
  title: string;
  url: string;
}

interface IProps {
  pdfs: IPdfs[];
  stream_key: string;
  videoIds?: number[];
  load: any;
  title: string;
}

const VideoPDF = ({ pdfs = [], stream_key, videoIds, load, title }: IProps) => {
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [fileList, setFileList] = useState<File[]>([]);
  const [uploadedPDFs, setUploadedPDFs] = useState<IPdfs[]>([]);
  const [inputTitle, setInputTitle] = useState(title || "");
  const fileInputRef = useRef<HTMLInputElement>(null);

  const token = localStorage.getItem("AUTH_TOKEN");

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files?.length) return;
    const files = Array.from(e.target.files);
    const invalid = files.find((file) => file.type !== "application/pdf");
    if (invalid) {
      messageApi.error("Only PDF files are allowed!");
      if (fileInputRef.current) fileInputRef.current.value = "";
      return;
    }
    setFileList(files);
  };

  const handleRemoveFile = () => {
    setFileList([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleUpload = async () => {
    if (fileList.length === 0) {
      messageApi.warning("Please select a PDF first");
      return;
    }

    if (!inputTitle) {
      messageApi.warning("Please enter a title");
      return;
    }

    setLoading(true);

    const formData = new FormData();
    formData.append("stream_key", stream_key);
    fileList.forEach((file) => {
      formData.append("pdfs", file);
    });

    try {
      const { data } = await api.post(NEW_BASE_URL + "videos/pdf", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (data.urls?.length) {
        messageApi.success("PDFs uploaded!");
        await load();
        setUploadedPDFs((prev) => [...prev, ...data.urls]);
        setFileList([]);

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        messageApi.error("Upload failed");
      }
    } catch (err) {
      console.error(err);
      messageApi.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // const handleSync = async () => {
  //   const allPDFs = [...pdfs, ...uploadedPDFs];

  //   if (allPDFs?.length === 0) {
  //     messageApi.warning("No PDFs to sync");
  //     return;
  //   }

  //   try {
  //     setLoading(true);

  //     const res = await recordApi.post(
  //       `videos/update-meta`,
  //       {
  //         stream_key,
  //         pdfs: allPDFs,
  //       },
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       },
  //     );

  //     if (res?.status === 200) {
  //       messageApi.success("PDFs synced successfully!");
  //       setUploadedPDFs([]);
  //       load();
  //     }
  //   } catch (err) {
  //     messageApi.error("Sync failed");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const handleDeleteExisting = (url: string) => {
    const updated = pdfs.filter((pdf) => pdf.url !== url).map((pdf) => pdf.url);

    console.log(updated, "updated pdf urls");

    handleImmediateUpdate(updated);
  };

  const handleImmediateUpdate = async (updatedPDFs: string[]) => {
    try {
      setLoading(true);
      const res = await studioApi.post(
        `/cms/videos/update-video`,
        {
          videoIds: videoIds.map(Number),
          pdfs: updatedPDFs,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res?.status === 200) {
        messageApi.success("Updated successfully");
        load();
      }
    } catch {
      messageApi.error("Update failed");
    } finally {
      setLoading(false);
    }
  };
  // const handleDeleteUploaded = (index: number) => {
  //   setUploadedPDFs((prev) => prev.filter((_, i) => i !== index));
  // };

  return (
    <div className="w-full border border-slate-200 bg-white shadow-sm overflow-hidden text-sm text-slate-700">
      {contextHolder}
      <div className="flex items-center justify-between border-b border-slate-200 bg-slate-50/70 px-4 py-3">
        <span className="font-bold text-slate-800 text-base">
          Supporting PDF
        </span>
        {/* <button
          disabled={loading}
          onClick={handleSync}
          className="px-3 py-1.5 text-xs font-semibold tracking-wide text-white bg-indigo-600 hover:bg-indigo-700 disabled:bg-slate-200 disabled:text-slate-400 rounded shadow-sm transition cursor-pointer"
        >
          {loading ? "Syncing..." : "Sync supporting pdf with Admin"}
        </button> */}
      </div>
      <div className="p-4 flex flex-col gap-4 max-w-xl">
        <div className="flex flex-col gap-1.5">
          <label className="text-blue-900 font-semibold text-xs uppercase tracking-wider">
            Title
          </label>
          <input
            type="text"
            value={inputTitle}
            onChange={(e) => setInputTitle(e.target.value)}
            className="w-full rounded border border-slate-200 px-3 py-2 text-sm bg-white focus:outline-none focus:border-indigo-500"
            placeholder="Enter PDF Title"
          />
        </div>
        <div className="flex flex-col gap-1.5">
          <label className="text-blue-900 font-semibold text-xs uppercase tracking-wider">
            {loading
              ? "Uploading..."
              : `Upload ${fileList.length || ""} PDF${
                  fileList.length > 1 ? "s" : ""
                }`}
          </label>
          <div className="flex items-center gap-3">
            <label className="shrink-0 px-3 py-1.5 text-xs font-medium border border-slate-200 rounded hover:bg-slate-50 transition cursor-pointer bg-white shadow-sm">
              Select Supporting PDF
              <input
                type="file"
                ref={fileInputRef}
                accept="application/pdf"
                onChange={handleFileChange}
                className="hidden"
                multiple
              />
            </label>
            {fileList.length > 0 && (
              <div className="flex flex-col gap-2">
                {fileList.map((file, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-2 bg-slate-50 border border-slate-100 px-2 py-1 rounded text-xs"
                  >
                    <span className="truncate flex-1">{file.name}</span>
                    <button
                      type="button"
                      onClick={() =>
                        setFileList((prev) =>
                          prev.filter((_, i) => i !== index)
                        )
                      }
                      className="text-red-500 font-bold cursor-pointer"
                    >
                      ✕
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <button
          type="button"
          disabled={loading}
          onClick={handleUpload}
          className="w-full text-center px-4 py-2 text-xs font-semibold tracking-wide text-white bg-blue-900 disabled:bg-slate-200 disabled:text-slate-400 rounded shadow-sm transition cursor-pointer"
        >
          {loading ? "Uploading..." : "Upload PDF"}
        </button>
      </div>

      <div className="w-full divide-y divide-slate-100 border-t border-slate-200">
        {pdfs?.length > 0 && (
          <div className="bg-slate-50/40">
            <div className="px-4 py-2 font-bold text-slate-800 bg-slate-100/60 text-xs uppercase tracking-wider border-b border-slate-100">
              Existing PDFs
            </div>
            <div className="divide-y divide-slate-100">
              {pdfs.map((pdf, index) => (
                <div
                  key={`existing-${index}`}
                  className="grid grid-cols-4 items-center px-4 py-2.5"
                >
                  <div className="text-blue-900 font-medium col-span-1 truncate pr-2">
                    {pdf.title}
                  </div>
                  <div className="col-span-3 flex items-center justify-between gap-4">
                    <a
                      href={pdf.url}
                      target="_blank"
                      rel="noreferrer"
                      className="font-mono text-xs text-indigo-600 hover:text-indigo-800 hover:underline truncate"
                    >
                      {pdf.url}
                    </a>
                    <button
                      type="button"
                      disabled={loading}
                      onClick={() => handleDeleteExisting(pdf.url)}
                      className="shrink-0 px-2 py-1 text-xs font-semibold text-rose-600 border border-rose-200 hover:bg-rose-50 rounded transition cursor-pointer disabled:opacity-40"
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VideoPDF;
